'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = initializeFirebase;

var _firebase = require('firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _initUtils = require('./initUtils');

var _initUtils2 = _interopRequireDefault(_initUtils);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Create middleware.


function initializeFirebase(config) {
  _firebase2.default.initializeApp(config);

  var googleAuth = new _firebase2.default.auth.GoogleAuthProvider();
  googleAuth.addScope('https://www.googleapis.com/auth/plus.login');
  return _extends({}, (0, _initUtils2.default)(_firebase2.default, config), {
    TIMESTAMP: _firebase2.default.database.ServerValue.TIMESTAMP,
    storage: _firebase2.default.storage().ref(),
    googleAuth: googleAuth
  });
}